import React from "react";
import { Checkbox } from "../ui/checkbox";

export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"]
];

export const money = (n) => `$${(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const Field = ({ label, children, wide }) => (
  <div className={wide ? "sm:col-span-2" : ""}>
    <label className="text-xs font-semibold text-knight-navy/70 mb-1.5 block">{label}</label>
    {children}
  </div>
);

export const Agree = ({ label, checked, onCheck }) => (
  <label className="flex items-start gap-3 cursor-pointer">
    <Checkbox checked={checked} onCheckedChange={(v) => onCheck(Boolean(v))} className="mt-0.5" />
    <span className="text-sm text-knight-navy/85 leading-relaxed">{label}</span>
  </label>
);

export const Row = ({ label, value }) => (
  <div className="flex items-center justify-between">
    <span className="text-knight-navy/65">{label}</span>
    <span className="font-bold text-knight-navy">{value}</span>
  </div>
);

export const CardBadge = ({ label }) => (
  <span className="inline-flex items-center justify-center px-2 py-1 rounded-md bg-slate-100 text-[10px] font-bold tracking-wider text-knight-navy/70 border border-slate-200">{label}</span>
);
